import { InputLabel, MenuItem } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __ACT_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { ValoreDominioVO } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { Operation } from 'shell/view-models/operation';
import { paginationListToQueryString } from 'system/utils/list-object-to-query-string';
import { OperationObject } from 'system/utils/operation-object-to-query-string';

const filters: OperationObject = {
  idDominio: {
    value: 11,
    operation: Operation.EQUALS,
  },
};

interface ListIstatProps {
  disabled?: boolean;
  required?: boolean;
  value: string;
  onChange: (value?: ItemVM) => void;
  error?: boolean;
  isSmallSize?: boolean;
  label?: string;
}

const ListIstatComponent = ({
  label = 'Tipo luogo evento',
  disabled,
  required,
  onChange,
  value,
  error,
  isSmallSize = false,
}: ListIstatProps): React.ReactElement => {
  const [istats] = useHttpFetch<HttpResponse<Array<ValoreDominioVO>>, Array<ItemVM>>(
    `${__ACT_API_URL__}/valori-dominio-atti`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        params: {},
        paramsSerializer: () =>
          `${paginationListToQueryString({
            filters,
            orders: {},
          })}`,
      },
      transformer: (response) =>
        ((response.data.payload || []) as Array<ValoreDominioVO>).map((item) => ({
          id: item.key?.idValore,
          value: item.descrizioneBreveValore,
        })) as Array<ItemVM>,
    }
  );

  const istatsData: Array<ItemVM> = (istats.data || []) as Array<ItemVM>;

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled} id="istat-label">
        {`${label}${required ? ' *' : ''}`}
      </InputLabel>
      <PmiSelect
        labelId="istat-label"
        id="istat"
        name="istat"
        value={value}
        label={`${label}${required ? ' *' : ''}`}
        onChange={(event) => onChange(istatsData?.find((item) => item.id === event.target.value))}
        disabled={disabled}
        error={error}
        size={isSmallSize ? 'small' : undefined}
      >
        {istatsData?.map((istat: ItemVM) => (
          <MenuItem key={istat.id} value={istat.id}>
            {istat.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ListIstatComponent.displayName = 'List Istat component';

const ListIstat = memo(ListIstatComponent);

export default ListIstat as typeof ListIstatComponent;
